import { CRS, Transformation } from 'leaflet';
import { MAP_MAX_ZOOM } from 'components/Map/constants';

const mapMaxZoom = MAP_MAX_ZOOM;
const tileExtent = [0.0, -3000.0, 5220.0, 0.0];

const mapMaxResolution = 1.0;
const mapMinResolution = Math.pow(2, mapMaxZoom) * mapMaxResolution;

const crs = {
  ...CRS.Simple,
  transformation: new Transformation(1, -tileExtent[0], -1, tileExtent[3]),
};
crs.scale = (zoom) => Math.pow(2, zoom) / mapMinResolution;
crs.zoom = (scale) => Math.log(scale * mapMinResolution) / Math.LN2;

export default crs;